import { render, staticRenderFns } from "./PlayCard.vue?vue&type=template&id=3ae64490&scoped=true"
import script from "./PlayCard.vue?vue&type=script&lang=js"
export * from "./PlayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae64490",
  null
  
)

export default component.exports